export const INDX={
    PROJECT_ID: 'projectId',
    PROJECT_NAME: '工程名称',
    INDEX: '序号'
}

export const TREE={
    ID: '_id',
    LABEL: 'label'
}

export const PROJ = {
    BASE: '基本信息',
    INFO: '工程概况',
    FEATURE: '工程特征',
    TYPE: '工程类型',
    BASE_TITLE: '工程名称',
    BASE_SN: '项目编号',
    BASE_ASSIGNEE: '项目参与人',
    INFO_CONTAINS_PROFESSION: '包含工程内容'
}
export const PROJ_CHAIN={
    PROJ_TITLE: PROJ.BASE+'.'+PROJ.BASE_TITLE,
    PROJ_SN: PROJ.BASE+'.'+PROJ.BASE_SN,
    PROJ_ASSIGNEE: PROJ.BASE+'.'+PROJ.BASE_ASSIGNEE
}
export function getProjectType(project){
    if(project){
        return project[PROJ.TYPE]
    }
    
}
export function setProjectType(project, value){
    if(project){
        project[PROJ.TYPE]=value
    }
    
}
export function getProjectTitle(project){
    if(project && project[PROJ.BASE]){
        return project[PROJ.BASE][PROJ.BASE_TITLE]
    }
    
}
export function setProjectTitle(project, value){
    if(project){
        if(!project[PROJ.BASE]){
            project[PROJ.BASE] = {} 
        }
        project[PROJ.BASE][PROJ.BASE_TITLE] = value
    }
}
export function getProjectSn(project){
    if(project && project[PROJ.BASE]){
        return project[PROJ.BASE][PROJ.BASE_SN]
    }
    
}
export function setProjectSn(project, value){
    if(project){
        if(!project[PROJ.BASE]){
            project[PROJ.BASE] = {} 
        }
        project[PROJ.BASE][PROJ.BASE_SN] = value
    }
}
export function getProjectAssignee(project){
    if(project && project[PROJ.BASE]){
        return project[PROJ.BASE][PROJ.BASE_ASSIGNEE]
    }
    
}
export function setProjectAssignee(project, value){
    if(project){
        if(!project[PROJ.BASE]){
            project[PROJ.BASE] = {} 
        }
        project[PROJ.BASE][PROJ.BASE_ASSIGNEE] = value
    }
}
export function getContainsProfessions(project){
    if(project){
        if(project[PROJ.INFO]){
            // const rules = project[PROJ.INFO][PROJ.INFO_CONTAINS_PROFESSION]
            // if(rules){
            //     return Object.keys(rules)
            // }
            return  project[PROJ.INFO][PROJ.INFO_CONTAINS_PROFESSION]
        }
    }
}